export enum BoxState {
    empty,
    under_upload,
    in_container,
    delivering,
}
